// Campus photo for /colleges/colorado-school-of-mines: CC BY 2.0, by Luke Jones from Anchorage, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMines-GuggenheimHall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/colorado-school-of-mines/; credited under the photo.
const photo = {
    "slug": "colorado-school-of-mines",
    "alt": "Guggenheim Hall at Colorado School of Mines, with its clock tower and red tile roof, across a lawn below the hillside white M in Golden, Colorado",
    "src": "/colleges/colorado-school-of-mines/campus-1600.webp",
    "srcSmall": "/colleges/colorado-school-of-mines/campus-800.webp",
    "srcMid": "/colleges/colorado-school-of-mines/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/colorado-school-of-mines/og.jpg",
    "title": "Mines-GuggenheimHall",
    "author": "Luke Jones from Anchorage",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMines-GuggenheimHall.jpg",
    "read": "2026-10-01"
};

export default photo;
